<mat-form-field appearance="outline" subscriptSizing="dynamic" class="lookup-source-fields__field">
  <mat-label>{{ 'TRANS__IMPORT__LOOKUP_REF' | translate }}</mat-label>
  <mat-select [formControl]="row.lookupRefControl">
    @for (lookup of lookups; track lookup.key) {
      <mat-option [value]="lookup.key">
        {{ lookupName(lookup) }}
        @if (lookup.codeColumnControl.value; as codeColumn) {
          <span class="lookup-source-fields__source-column">{{ codeColumn }}</span>
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (valueColumns(); as columns) {
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="lookup-source-fields__field">
    <mat-label>{{ 'TRANS__IMPORT__LOOKUP_LABEL_COLUMN' | translate }}</mat-label>
    <mat-select [formControl]="row.lookupLabelControl">
      @for (col of columns; track col.name) {
        <mat-option [value]="col.name">{{ col.name }}</mat-option>
      }
    </mat-select>
    @if (isLoadingColumns()) {
      <mat-hint>{{ 'TRANS__IMPORT__LOOKUP_LOADING_COLUMNS' | translate }}</mat-hint>
    }
  </mat-form-field>
}
